
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component } from 'vue-property-decorator';

const SportsDefaultFooter = () =>
	import(/* webpackChunkName: "default-footer" */ '@/components/sports/common/SportsDefaultFooter.vue');

import { UrlMetadataResponse } from '@/interfaces/responses/url-metadata';

const Routing = namespace('routing');

@Component({
	name: 'SportsFooter',
	components: {
		SportsDefaultFooter,
	},
})
export default class SportsFooter extends Vue {
	coldStart = true;
	metaReady: boolean = false;

	@Routing.State urlMetadataPromise: Promise<UrlMetadataResponse> | null;

	get showDefaultFooter() {
		return this.$route.name !== 'app.home';
	}

	async created() {
		await this.urlMetadataPromise;
		this.metaReady = true;
	}

	mounted() {
		this.coldStart = false;
	}
}
